import api from '../../utils/helpers/api'

type ResponType = {
  data: any
  meta: object
}

const uriProficiency = 'master/proficiency'
const uriUniversity = 'master/university'
const uriMajor = 'master/major'
const uriDegree = 'master/degree'
const uriWorkingType = 'master/working-type'
const uriIndustry = 'master/industry'
const uriSkill = 'master/skill'
const uriSeniorityLevel = 'master/seniority-level'
const uriJobLevel = 'master/job-level'
const uriLanguage = 'master/language'
const uriCountry = 'master/country'
const uriCountryHash = 'master/country-list-hash'
const uriCity = 'master/city'
const uriProvince = 'master/province'
const uriVillage = 'master/village'
const uriCompanyOwnership = 'master/company-ownership'
const uriAlumni = 'user'
const uriCompany = 'company'
const uriCompanySize = 'master/company-size'
const uriJob = 'company-job'
const uriOwnership = 'master/company-ownership'
const approveCompany = 'approval'
const approval = 'master/approval-type'
const uriApprovalUser = 'master/approval-type-user'
const uriRole = 'master/role'
const uriAssignRole = 'assign-user'
const uriUser = 'user'
const uriAuthObjectList = 'auth-object-list'
const uriModule = 'master/all-modules'
const uriCompanyProfile = 'company-profile'
const uriStatusCompany = 'company-job-status'
const uriLog = 'log/activity'
const uriDistrict = 'master/district'
const uriSyncAlumniJob = 'master/sync-job-alumni'
const uriLastSyncAlumniJob = 'master/last-sync-job-alumni'
const urlLanguage = '/list/bahasa'
const urlCountry = '/list/tesis/country/publish'
const uriBidangKeilmuan = '/list/bidang-keilmuan'
const uriPublishDate = '/list/tesis/date/publish'
const uriThesisList = '/list/tesis/user'
const uriStoreThesis = '/store/tesis'

// CoP
const uriCOPBanners = 'cop/banner'
const uriCOPVideos = 'cop/youtube'
const uriCOPCategories = 'cop/kategori-berita'
const uriCOPNews = 'cop/berita'
const uriCOPDashboard = 'cop/dashboard'

const master = {
  getThesisLanguage: async () => {
    return (await api.get(urlLanguage)) as Promise<ResponType>
  },
  getThesisCountry: async () => {
    return (await api.get(urlCountry)) as Promise<ResponType>
  },
  getThesisBidangKeilmuan: async (param: any) => {
    return (await api.get(`${uriBidangKeilmuan}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getThesisPublishDate: async () => {
    return (await api.get(uriPublishDate)) as Promise<ResponType>
  },
  getThesisList: async (param: any) => {
    return (await api.get(uriThesisList, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeThesis: async (data: any) => {
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }
    return (await api.post(`${uriStoreThesis}`, formData)) as Promise<ResponType>
  },
  syncAlumniJob: async () => {
    return (await api.post(uriSyncAlumniJob)) as Promise<ResponType>
  },
  getLastSyncAlumniJob: async () => {
    return (await api.get(uriLastSyncAlumniJob)) as Promise<ResponType>
  },
  getDistrict: async (params: any) => {
    return (await api.get(uriDistrict, {params})) as Promise<ResponType>
  },
  getDistrictHash: async (param: any) => {
    return (await api.get(`${uriDistrict}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeDistrict: async (data: any) => {
    return (await api.post(uriDistrict, data)) as Promise<ResponType>
  },
  updateDistrict: async (data: any) => {
    return (await api.put(`${uriDistrict}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteDistrict: async (id: any) => {
    return (await api.delete(`${uriDistrict}/${id}`)) as Promise<ResponType>
  },
  getCompanyProfile: async (param: any) => {
    return (await api.get(`${uriCompanyProfile}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  updateCompanyProfile: async (data: any) => {
    return (await api.put(`${uriCompanyProfile}-update`, data)) as Promise<ResponType>
  },
  getAlumni: async (param: any) => {
    return (await api.get(`${uriAlumni}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getAlumniHash: async (param: any) => {
    return (await api.get(`${uriAlumni}/list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeAlumni: async (data: any) => {
    return (await api.post(`${uriAlumni}`, data)) as Promise<ResponType>
  },
  updateAlumni: async (data: any) => {
    return (await api.get(`${uriAlumni}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteAlumni: async (id: any) => {
    return (await api.delete(`${uriAlumni}/${id}`)) as Promise<ResponType>
  },
  getCompanySize: async (param: any) => {
    return (await api.get(`${uriCompanySize}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getCompanySizeHash: async (param: any) => {
    return (await api.get(`${uriCompanySize}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCompanySize: async (data: any) => {
    return (await api.post(uriCompanySize, data)) as Promise<ResponType>
  },
  updateCompanySize: async (data: any) => {
    return (await api.get(`${uriCompanySize}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteCompanySize: async (id: any) => {
    return (await api.delete(`${uriCompanySize}/${id}`)) as Promise<ResponType>
  },
  getCompany: async (params: any) => {
    return (await api.get(uriCompany, {params})) as Promise<ResponType>
  },
  getCompanyHash: async (param: any) => {
    return (await api.get(`${uriCompany}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCompany: async (data: any) => {
    return (await api.post(uriCompany, data)) as Promise<ResponType>
  },
  updateCompany: async (data: any) => {
    return (await api.put(`${uriCompany}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteCompany: async (id: any) => {
    return (await api.delete(`${uriCompany}/${id}`)) as Promise<ResponType>
  },
  getCompanyOwnership: async (param: any) => {
    return (await api.get(uriCompanyOwnership, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getCompanyOwnershipHash: async (param: any) => {
    return (await api.get(`${uriCompanyOwnership}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCompanyOwnership: async (data: any) => {
    return (await api.post(uriCompanyOwnership, data)) as Promise<ResponType>
  },
  updateCompanyOwnership: async (data: any) => {
    return (await api.put(`${uriCompanyOwnership}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteCompanyOwnership: async (id: any) => {
    return (await api.delete(`${uriCompanyOwnership}/${id}`)) as Promise<ResponType>
  },
  getJob: async (param: any) => {
    return (await api.get(`${uriJob}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getJobHash: async (param: any) => {
    return (await api.get(`${uriJob}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeJob: async (data: any) => {
    return (await api.post(uriJob, data)) as Promise<ResponType>
  },
  updateJob: async (data: any) => {
    return (await api.get(`${uriJob}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteJob: async (id: any) => {
    return (await api.delete(`${uriJob}/${id}`)) as Promise<ResponType>
  },
  getLanguage: async (params: any) => {
    return (await api.get(uriLanguage, {params})) as Promise<ResponType>
  },
  getLanguageHash: async (param: any) => {
    return (await api.get(`${uriLanguage}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeLanguage: async (data: any) => {
    return (await api.post(uriLanguage, data)) as Promise<ResponType>
  },
  updateLanguage: async (data: any) => {
    return (await api.put(`${uriLanguage}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteLanguage: async (id: any) => {
    return (await api.delete(`${uriLanguage}/${id}`)) as Promise<ResponType>
  },
  getOwnership: async (params: any) => {
    return (await api.get(uriOwnership, {params})) as Promise<ResponType>
  },
  getOwnershipHash: async (param: any) => {
    return (await api.get(`${uriOwnership}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeOwnership: async (data: any) => {
    return (await api.post(`${uriOwnership}`, data)) as Promise<ResponType>
  },
  updateOwnership: async (data: any) => {
    return (await api.put(`${uriOwnership}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteOwnership: async (id: any) => {
    return (await api.delete(`${uriOwnership}/${id}`)) as Promise<ResponType>
  },
  getProficiency: async (params?: any) => {
    return (await api.get(uriProficiency, {params: params})) as Promise<ResponType>
  },
  getProficiencyHash: async (param: any) => {
    return (await api.get(`${uriProficiency}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeProficiency: async (data: any) => {
    return (await api.post(`${uriProficiency}`, data)) as Promise<ResponType>
  },
  updateProficiency: async (data: any) => {
    return (await api.put(`${uriProficiency}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteProficiency: async (id: any) => {
    return (await api.delete(`${uriProficiency}/${id}`)) as Promise<ResponType>
  },
  getUniversities: async (param: any) => {
    return (await api.get(uriUniversity, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getMajor: async (param: any) => {
    return (await api.get(uriMajor, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getMajorHash: async (param: any) => {
    return (await api.get(`${uriMajor}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeMajor: async (data: any) => {
    return (await api.post(`${uriMajor}`, data)) as Promise<ResponType>
  },
  updateMajor: async (data: any) => {
    return (await api.put(`${uriMajor}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteMajor: async (id: any) => {
    return (await api.delete(`${uriMajor}/${id}`)) as Promise<ResponType>
  },
  getDegree: async (param: any) => {
    return (await api.get(uriDegree, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getDegreeHash: async (param: any) => {
    return (await api.get(`${uriDegree}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeDegree: async (data: any) => {
    return (await api.post(`${uriDegree}`, data)) as Promise<ResponType>
  },
  updateDegree: async (data: any) => {
    return (await api.put(`${uriDegree}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteDegree: async (id: any) => {
    return (await api.delete(`${uriDegree}/${id}`)) as Promise<ResponType>
  },
  approveCompany: async (data: any) => {
    return (await api.post(`${approveCompany}`, data)) as Promise<ResponType>
  },
  getApproval: async (param: any) => {
    return (await api.get(`${approval}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeApprovalUser: async (data: any) => {
    return (await api.post(`${uriApprovalUser}`, data)) as Promise<ResponType>
  },
  getApprovalHash: async (param: any) => {
    return (await api.get(`${approval}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  showUser: async (id: any) => {
    if (id) {
      return (await api.get(`${uriUser}/${id}`)) as Promise<ResponType>
    }
  },
  storeApproval: async (data: any) => {
    return (await api.post(`${uriVillage}`, data)) as Promise<ResponType>
  },
  updateApproval: async (data: any) => {
    return (await api.put(`${uriVillage}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteApproval: async (id: any) => {
    return (await api.delete(`${uriVillage}/${id}`)) as Promise<ResponType>
  },
  updateJobStatus: async (data: any) => {
    const payload = {
      status: data.status,
    }
    return (await api.put(
      `${uriStatusCompany}/${data.company_job_id}`,
      payload
    )) as Promise<ResponType>
  },
  getWorkingType: async (params: any) => {
    return (await api.get(uriWorkingType, {params})) as Promise<ResponType>
  },
  getWorkingTypeHash: async (param: any) => {
    return (await api.get(`${uriWorkingType}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeWorkingType: async (data: any) => {
    return (await api.post(`${uriWorkingType}`, data)) as Promise<ResponType>
  },
  updateWorkingType: async (data: any) => {
    return (await api.put(`${uriWorkingType}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteWorkingType: async (id: any) => {
    return (await api.delete(`${uriWorkingType}/${id}`)) as Promise<ResponType>
  },
  getIndustry: async (params: any) => {
    return (await api.get(uriIndustry, {params})) as Promise<ResponType>
  },
  getIndustryHash: async (param: any) => {
    return (await api.get(`${uriIndustry}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeIndustry: async (data: any) => {
    return (await api.post(`${uriIndustry}`, data)) as Promise<ResponType>
  },
  updateIndustry: async (data: any) => {
    return (await api.put(`${uriIndustry}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteIndustry: async (id: any) => {
    return (await api.delete(`${uriIndustry}/${id}`)) as Promise<ResponType>
  },
  getSkill: async (params: any) => {
    return (await api.get(`${uriSkill}`, {params})) as Promise<ResponType>
  },
  getSkillHash: async (param: any) => {
    return (await api.get(`${uriSkill}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeSkill: async (data: any) => {
    return (await api.post(`${uriSkill}`, data)) as Promise<ResponType>
  },
  updateSkill: async (data: any) => {
    return (await api.put(`${uriSkill}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteSkill: async (id: any) => {
    return (await api.delete(`${uriSkill}/${id}`)) as Promise<ResponType>
  },
  getSeniorityLevel: async (param: any) => {
    return (await api.get(`${uriSeniorityLevel}`, {
      params: {param},
    })) as Promise<ResponType>
  },
  getJobLevelHash: async (param: any) => {
    return (await api.get(`${uriJobLevel}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getJobLevel: async (params: any) => {
    return (await api.get(uriJobLevel, {params})) as Promise<ResponType>
  },
  storeJobLevel: async (data: any) => {
    return (await api.post(`${uriJobLevel}`, data)) as Promise<ResponType>
  },
  updateJobLevel: async (data: any) => {
    return (await api.put(`${uriJobLevel}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteJobLevel: async (id: any) => {
    return (await api.delete(`${uriJobLevel}/${id}`)) as Promise<ResponType>
  },
  getCountryHash: async (param: any) => {
    return (await api.get(uriCountryHash, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getCountry: async (params: any) => {
    return (await api.get(uriCountry, {params})) as Promise<ResponType>
  },
  storeCountry: async (data: any) => {
    return (await api.post(`${uriCountry}`, data)) as Promise<ResponType>
  },
  updateCountry: async (data: any) => {
    return (await api.put(`${uriCountry}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteCountry: async (id: any) => {
    return (await api.delete(`${uriCountry}/${id}`)) as Promise<ResponType>
  },
  getCity: async (params: any) => {
    return (await api.get(uriCity, {params})) as Promise<ResponType>
  },
  getCityHash: async (param: any) => {
    return (await api.get(`${uriCity}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCity: async (data: any) => {
    return (await api.post(`${uriCity}`, data)) as Promise<ResponType>
  },
  updateCity: async (data: any) => {
    return (await api.put(`${uriCity}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteCity: async (id: any) => {
    return (await api.delete(`${uriCity}/${id}`)) as Promise<ResponType>
  },
  getUniversityHash: async (param: any) => {
    return (await api.get(`${uriUniversity}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getUniversity: async (param: any) => {
    return (await api.get(uriUniversity, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeUniversity: async (data: any) => {
    return (await api.post(`${uriUniversity}`, data)) as Promise<ResponType>
  },
  updateUniversity: async (data: any) => {
    return (await api.put(`${uriUniversity}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteUniversity: async (id: any) => {
    return (await api.delete(`${uriUniversity}/${id}`)) as Promise<ResponType>
  },
  getProvince: async (params: any) => {
    return (await api.get(uriProvince, {params})) as Promise<ResponType>
  },
  getProvinceHash: async (param: any) => {
    return (await api.get(`${uriProvince}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeProvince: async (data: any) => {
    return (await api.post(`${uriProvince}`, data)) as Promise<ResponType>
  },
  updateProvince: async (data: any) => {
    return (await api.put(`${uriProvince}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteProvince: async (id: any) => {
    return (await api.delete(`${uriProvince}/${id}`)) as Promise<ResponType>
  },
  getVillage: async (param: any) => {
    return (await api.get(uriVillage, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getVillageHash: async (param: any) => {
    return (await api.get(`${uriVillage}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeVillage: async (data: any) => {
    return (await api.post(`${uriVillage}`, data)) as Promise<ResponType>
  },
  updateVillage: async (data: any) => {
    return (await api.put(`${uriVillage}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteVillage: async (id: any) => {
    return (await api.delete(`${uriVillage}/${id}`)) as Promise<ResponType>
  },
  getModule: async () => {
    return (await api.get(uriModule)) as Promise<ResponType>
  },
  updateModule: async (data: any) => {
    return (await api.put(`${uriRole}/${data.id}/edit-auth-object`, data)) as Promise<ResponType>
  },
  getRoleModule: async (param: any) => {
    return (await api.get(`${uriRole}/${param?.id}/${uriAuthObjectList}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getRoleHash: async (param: any) => {
    return (await api.get(`${uriRole}-list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getRole: async (param: any) => {
    return (await api.get(uriRole, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeRole: async (data: any) => {
    return (await api.post(`${uriRole}`, data)) as Promise<ResponType>
  },
  updateRole: async (data: any) => {
    return (await api.put(`${uriRole}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteRole: async (id: any) => {
    return (await api.delete(`${uriRole}/${id}`)) as Promise<ResponType>
  },
  getUserHash: async (param: any) => {
    return (await api.get(`${uriUser}/list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getUser: async (param: any) => {
    return (await api.get(uriUser, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeUser: async (data: any) => {
    return (await api.post(`${uriUser}`, data)) as Promise<ResponType>
  },
  updateUser: async (data: any) => {
    return (await api.put(`${uriUser}/${data.id}`, data)) as Promise<ResponType>
  },
  deleteUser: async (id: any) => {
    return (await api.delete(`${uriUser}/${id}`)) as Promise<ResponType>
  },
  updateStatusUser: async (data: any) => {
    return (await api.put(`${uriUser}/${data.id}/update-status`, data)) as Promise<ResponType>
  },
  getLog: async (params: any) => {
    return (await api.get(uriLog, {params})) as Promise<ResponType>
  },
  // COP
  getCOPBanners: async (param: any) => {
    return (await api.get(`${uriCOPBanners}/list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCOPBanner: async (data: any) => {
    return (await api.post(`${uriCOPBanners}`, data)) as Promise<ResponType>
  },
  updateCOPBanner: async (id: any, data: any) => {
    return (await api.post(`${uriCOPBanners}/${id}`, data)) as Promise<ResponType>
  },
  deleteCOPBanner: async (id: any) => {
    return (await api.delete(`${uriCOPBanners}/${id}`)) as Promise<ResponType>
  },
  getCOPCategoryNoHash: async (param: any) => {
    return (await api.get(`${uriCOPCategories}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getCOPCategories: async (param: any) => {
    return (await api.get(`${uriCOPCategories}/list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCOPCategory: async (data: any) => {
    return (await api.post(`${uriCOPCategories}`, data)) as Promise<ResponType>
  },
  updateCOPCategory: async (id: any, data: any) => {
    return (await api.post(`${uriCOPCategories}/${id}`, data)) as Promise<ResponType>
  },
  deleteCOPCategory: async (id: any) => {
    return (await api.delete(`${uriCOPCategories}/${id}`)) as Promise<ResponType>
  },
  getCOPVideos: async (param: any) => {
    return (await api.get(`${uriCOPVideos}/list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCOPVideo: async (data: any) => {
    return (await api.post(`${uriCOPVideos}`, data)) as Promise<ResponType>
  },
  updateCOPVideo: async (id: any, data: any) => {
    return (await api.post(`${uriCOPVideos}/${id}`, data)) as Promise<ResponType>
  },
  deleteCOPVideo: async (id: any) => {
    return (await api.delete(`${uriCOPVideos}/${id}`)) as Promise<ResponType>
  },
  getCOPNews: async (param: any) => {
    return (await api.get(`${uriCOPNews}/list-hash`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  storeCOPNews: async (data: any) => {
    return (await api.post(`${uriCOPNews}`, data)) as Promise<ResponType>
  },
  updateCOPNews: async (id: any, data: any) => {
    return (await api.post(`${uriCOPNews}/${id}`, data)) as Promise<ResponType>
  },
  deleteCOPNews: async (id: any) => {
    return (await api.delete(`${uriCOPNews}/${id}`)) as Promise<ResponType>
  },
  getCOPDashboard: async (param: any) => {
    return (await api.get(`${uriCOPDashboard}`, {
      params: typeof param === 'object' ? param : {param},
    })) as Promise<ResponType>
  },
  getCOPDashboardExportNews: async (param: any) => {
    return (await api.get(`${uriCOPDashboard}/export/stats-by-news`, {params: typeof param === 'object' ? param : {param},})) as Promise<ResponType>
  },
  getCOPDashboardExportCategory: async (param: any) => {
    return (await api.get(`${uriCOPDashboard}/export/stats-by-category`, {params: typeof param === 'object' ? param : {param},})) as Promise<ResponType>
  },
}

export default master
